import React, { useState } from 'react';
import styles from './WorkplaceDoctorStatistics.module.scss';
import WorkplaceDoctorStatisticsFilter from './WorkplaceDoctorStatisticsFilter';
import WorkplaceDoctorStatisticsTable from './WorkplaceDoctorStatisticsTable';
import useWorkplaceDoctorStatistics from '../Hooks/useWorkplaceDoctorStatistics';

const WorkplaceDoctorStatistics: React.FC = () => {
	const [isFilterReady, setIsFilterReady] = useState(false);
	const { data, setFilter } = useWorkplaceDoctorStatistics(isFilterReady);

	return (
		<div className={styles.wrapper}>
			<WorkplaceDoctorStatisticsFilter
				onFilter={setFilter}
				onReady={() => setIsFilterReady(true)}
			/>
			<WorkplaceDoctorStatisticsTable data={data} />
		</div>
	);
};

export default WorkplaceDoctorStatistics;
